// actions
const SHOW_MODAL = 'SHOW_MODAL'
const HIDE_MODAL = 'HIDE_MODAL'

// reducer
const initialState = {
  modalData: null,
  open: false,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_MODAL:
      const { modalData } = action
      return Object.assign({}, state, {
        modalData,
        open: true,
      })

    case HIDE_MODAL:
      return Object.assign({}, state, {
        modalData: null,
        open: false,
      })

    default:
      return state
  }
};

// action creators
export const showModal = (modalData) => {
  return {
    type: SHOW_MODAL,
    modalData,
  }
}

export const hideModal = () => {
  return {
    type: HIDE_MODAL,
  }
}
